<template>
  <div class="page-column">
    <MatchHeader/>
    <EventMenu />
    <div >
      <HomeIndex v-if="activeIndex == 0"></HomeIndex>
      <NewsIndex v-if="activeIndex == 1"></NewsIndex>
      <MatchIndex v-if="activeIndex == 2"></MatchIndex>
      <SporterRanking v-if="activeIndex == 3"></SporterRanking>
      <ClubRanking v-if="activeIndex == 4"></ClubRanking>
    </div>
  </div>
</template>

<script>
import HomeIndex from './home/HomeIndex.vue'
import MatchHeader from './MatchHeader.vue'
import EventMenu from './EventMenuList.vue'
import NewsIndex from './news/NewsIndex.vue'
import MatchIndex from './matchCell/MatchCell.vue'
import SporterRanking from './sporterRanking/SporterRanking.vue'
import ClubRanking from './clubRanking/ClubRanking.vue'
export default {
  components: {
    HomeIndex,
    MatchHeader,
    EventMenu,
    NewsIndex,
    MatchIndex,
    SporterRanking,
    ClubRanking
  },
  data () {
    return {
      activeIndex: 0
    }
  },
  created () {
    window.scrollTo(0, 0)
  },
  methods: {
    tabSwitch (val) {
      this.activeIndex = val
    }
  }
}
</script>
<style lang="scss" scoped>
.page-column {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  position: relative;
}

</style>



// WEBPACK FOOTER //
// src/daoba-match/views/event/EventDefault.vue